var successAnimationData = {
  v: '4.10.1',
  fr: 29.9700012207031,
  ip: 0,
  op: 28.0000011404634,
  w: 128,
  h: 128,
  nm: 'Success',
  ddd: 0,
  assets: [],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: 'Check',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [63, 59.5, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [64, 64, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0]],
            v: [[-27, 14], [-8, 30.75], [27.5, -14]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 1, 1, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 12,
          ix: 5
        },
        lc: 2,
        lj: 2,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [64, 64],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 1',
      np: 3,
      cix: 2,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'tm',
      s: {
        a: 0,
        k: 0,
        ix: 1
      },
      e: {
        a: 1,
        k: [{
          i: {
            x: [0.203],
            y: [0.996]
          },
          o: {
            x: [0.818],
            y: [0.013]
          },
          n: ['0p203_0p996_0p818_0p013'],
          t: 0,
          s: [0],
          e: [100]
        }, {
          t: 15.0000006109625
        }],
        ix: 2
      },
      o: {
        a: 0,
        k: 0,
        ix: 3
      },
      m: 1,
      ix: 2,
      nm: 'Trim Paths 1',
      mn: 'ADBE Vector Filter - Trim',
      hd: false
    }],
    ip: 0,
    op: 900.000036657751,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: 'Circle',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [64, 64, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 0,
          k: [114.584, 114.584],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 1, 1, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 12,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [-0.019, -0.196],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Ellipse 1',
      np: 3,
      cix: 2,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'tm',
      s: {
        a: 0,
        k: 0,
        ix: 1
      },
      e: {
        a: 0,
        k: 100,
        ix: 2
      },
      o: {
        a: 0,
        k: 0,
        ix: 3
      },
      m: 1,
      ix: 2,
      nm: 'Trim Paths 1',
      mn: 'ADBE Vector Filter - Trim',
      hd: false
    }],
    ip: 0,
    op: 900.000036657751,
    st: 0,
    bm: 0
  }]
};

export { successAnimationData as default };
